import MessageList from './MessageList';
import { aiChatShell } from '../../../styles/aiChatShell';

function TypingIndicator({ label }) {
    return (
        <div className={`${aiChatShell.msgAi} ${aiChatShell.msgCentered}`}>
            <div className={aiChatShell.typing}>
                <span className={aiChatShell.typingLabel}>{label}</span>
                <span className={aiChatShell.typingDots}>
                    <span className={aiChatShell.dot}></span>
                    <span className={aiChatShell.dot2}></span>
                    <span className={aiChatShell.dot3}></span>
                </span>
            </div>
        </div>
    );
}

/**
 * チャットメッセージ表示コンポーネント
 * hydrating: 履歴ロード中 / openingFetching: opening 取得中 → いずれも「準備中」
 */
export default function ChatMessages({
    messages,
    loading,
    purging,
    showLoadingIndicator,
    showTurn,
    onEdit,
    messagesBoxRef,
    hydrating,
    openingFetching
}) {
    if (purging) {
        return (
            <div className={aiChatShell.messages} ref={messagesBoxRef}>
                <TypingIndicator label="新しいチャットを準備中" />
            </div>
        );
    }

    if (messages.length === 0) {
        if (hydrating || openingFetching) {
            return (
                <div className={aiChatShell.messages} ref={messagesBoxRef}>
                    <TypingIndicator label="準備中" />
                </div>
            );
        }
        return (
            <div className={aiChatShell.empty}>メッセージはありません。質問を入力してください。</div>
        );
    }

    return (
        <MessageList
            messages={messages}
            loading={loading}
            purging={purging}
            showLoadingIndicator={showLoadingIndicator}
            showTurn={showTurn}
            onEdit={onEdit}
            messagesBoxRef={messagesBoxRef}
        />
    );
}
